import Icons from "../../../assets/js/Icons"
import { Button } from "@mui/material"
import { Link } from "react-router-dom"

function NavLink({ menu }) {
  return (
    <Button
      sx={{
        p: "0",
        color: "white",
        fontWeight: "400",
        transition: "all 175ms ease",
        ".MuiButton-icon": { mr: "2px" },
        "& span.text": { transition: "all 350ms ease" },
        ":hover": {
          color: "secondary.dark",
          "& span.text": {
            transform: "translateX(6px)",
            letterSpacing: "1px",
          }
        }
      }}
      disableRipple
      to={menu?.path}
      LinkComponent={Link}
      startIcon={<Icons.ArrowRight2 />}
    ><span className="text">{menu?.name}</span>
    </Button>
  )
}

export default NavLink